@if (skeleton) {
  <p-skeleton width="17rem" height="25rem" borderRadius="20px"></p-skeleton>
} @else {
  <div class="complementary-product-card">
    <div class="favorite-overlay">
      <fa-icon class="favorite" [icon]="faHeart" [class.filled]="product.inFavorite"
               (click)="toggleFavorite()"></fa-icon>
    </div>
    <div class="product" style="content-visibility: auto; contain-intrinsic-size: 420px 272px">
      <div class="product-thumbnail">
        <img
          alt="produit"
          [castoLazyImage]="productPicturePathFromContext(product)"
          class="product-thumbnail-img"
          [class.hidden]="!isImageLoaded"
          (click)="openProductLink(product)"
          (imageLoaded)="onImageLoad.emit()"
          width="176" height="176" />
        @if (!isImageLoaded) {
          <p-skeleton height="11rem" width="11rem"></p-skeleton>
        }
      </div>
      <div class="product-name">{{ product.label }}</div>
      <div class="product-info">
        <div class="product-price">{{ product.price| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
        </div>
        <div class="product-quantity">
          <ng-casto-button class="primary" [faIcon]="faMinus"
                           (click)="decrementProductQuantity()"
                           [disabled]="product.quantity < 1 || product.loading"></ng-casto-button>
          <p-inputNumber
            #pInput
            type="number"
            [ngModel]="product.quantity"
            (onInput)="onInputChange($event)"
            [min]="0"
            locale="fr-FR" />
          <ng-casto-button class="primary" [faIcon]="faPlus"
                           (click)="incrementProductQuantity()"
                           [disabled]="product.loading"></ng-casto-button>
        </div>

      </div>
      @if (product.quantity > 0) {
        <div class="product-sub-total">
          Sous-total : {{ product.price * product.quantity| currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
        </div>
      }
      <div class="add-to-cart">


        @if (product.inCart) {
          <ng-casto-button class="danger"
                           [label]="'complementary-products.remove-from-cart'|translate"
                           (click)="emitOnProductQuantityChange(0)"
                           [loading]="product.loading"
                           [disabled]="product.loading"></ng-casto-button>
        } @else {
          <ng-casto-button class="primary"
                           [label]="'complementary-products.add-to-cart'|translate"
                           (click)="emitOnProductQuantityChange(1)"
                           [loading]="product.loading"
                           [disabled]="product.loading"></ng-casto-button>
        }
      </div>
    </div>
  </div>
}
